import {
  DatePicker,
  DatePickerProps,
  Input,
  message,
  Select,
  Space,
} from "antd";
import { status } from "../../utils/constants";
import useCourseStore from "../../store/course";
import dayjs from "dayjs";
import { useState } from "react";
import { apiBaseURL } from "../../api";

export interface IQuery {
  title: string;
  vid?: string;
  status?: string;
  courseId?: string;
  date?: string;
  page: number;
  pageSize: number;
  videoType?: "yt,youtube" | "" | "kgs" | "youtube" | "yt";
  stream_key: string;
  lessonId?: string;
}

interface IProps {
  query: IQuery;
  setQuery: (query: object) => void;
  type: any;
}
type TLesson = { label: string; value: number };

function HistoryFilter({ query, setQuery, type }: IProps) {
  const { courses } = useCourseStore();

  const onDateChange: DatePickerProps["onChange"] = (date, dateString) => {
    setQuery({ date: dateString });
  };
  // const handleSelectCourse = (courseId: string) => {
  //   setQuery({ courseId });
  // };

  const [lessons, setLessons] = useState<TLesson[]>([]);
  const [selectedLesson, setSelectedLesson] = useState("");

  const handleSelectCourse = async (courseId: string) => {
    setQuery({ courseId, lessonId: "" });
    setLessons([]);
    setSelectedLesson("");
    if (!courseId) return;
    try {
      const { data } = await apiBaseURL.get<{ id: number; name: string }[]>(
        `lessons/v2/${courseId}`,
      );
      const formattedLessons = data.map((lesson) => ({
        label: `${lesson.id} - ${lesson.name}`,
        value: lesson.id,
      }));
      setLessons(formattedLessons);
    } catch (err) {
      message.error("Failed to fetch lessons");
    }
  };
  return (
    <div
      style={{
        overflowX: "auto",
        width: "100%",
        background:"rgba(0,0,0,0.02)",
        borderRadius:"0.5em",
        marginBottom:"1em"
      }}
    >
      <Space
        style={{
          display: "flex",
          gap:10,
          minWidth:"max-content",
          padding:10
        }}
      >
        <DatePicker
          onChange={onDateChange}
          defaultValue={query?.date ? dayjs(query.date) : undefined}
        />

        <Select
          showSearch
          allowClear
          onClear={() => setQuery({ courseId: "" })}
          style={{ width: 220 }}
          placeholder="Select the course"
          options={(courses || []).map((course) => ({
            label: `${course.id} - ${course.title}`,
            value: course.id,
          }))}
          onSelect={handleSelectCourse}
          filterOption={(input, option) =>
            option?.label
              ?.toString()
              .toLowerCase()
              .includes(input.toLowerCase())
          }
          defaultValue={query?.courseId === "" ? null : query?.courseId}
        />
        <Select
          showSearch
          allowClear
          style={{ width: 220 }}
          placeholder="Select lesson"
          options={lessons}
          value={query?.lessonId || undefined}
          onSelect={(value) => {
            setSelectedLesson(value);
            setQuery({ lessonId: value });
          }}
          onClear={() => setQuery({ lessonId: "" })}
          filterOption={(input, option) =>
            option?.label
              ?.toString()
              .toLowerCase()
              .includes(input.toLowerCase())
          }
        />
        <Select
          placeholder="Select Status"
          allowClear
          onClear={() => setQuery({ status: "" })}
          options={
            type == "yt"
              ? status.filter(
                  (datum) => datum.value == "ended" || datum.value == "live",
                )
              : status
          }
          onSelect={(value) => setQuery({ status: value })}
          defaultValue={query?.status === "" ? null : query?.status}
          style={{ width: 220 }}
        />
        <Input
        style={{ width: 220 }}
          onChange={(e) => setQuery({ title: e.target.value })}
          placeholder="Enter Title to Search"
          defaultValue={query?.title}
        />
        <Input
        style={{ width: 220 }}
          defaultValue={query?.vid}
          onChange={(e) => setQuery({ vid: e.target.value })}
          placeholder="Enter video id to Search"
        />
        <Input
        style={{ width: 220 }}
          defaultValue={query?.stream_key}
          onChange={(e) => setQuery({ stream_key: e.target.value })}
          placeholder="Enter Stream key to Search"
        />
      </Space>
    </div>
  );
}

export default HistoryFilter;
